/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:58:59
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-08 15:58:59
 */
import req from "@/utils/request";

//  添加账号
export const addAcc = (params) => req.post("/users/accountadd", params);

// 获取模板列表
export const getTemplateList = (params) => req.post("/site-service/m/site/template/list", params);

// 新增目录
export const addDirectory = (params) => req.post("/site-service/m/site/template/saveDirectory", params);

// 删除模板
export const removeTemplate = (params) => req.post("/site-service/m/site/template/removeTemplate", params);

// 文件详情
export const fileInfo = (params) => req.post("/site-service/m/site/template/fileInfo", params);

// 保存模板文件
export const saveTemplate = (params) => req.post("/site-service/m/site/template/saveTemplate", params);

// 上传文件模板
export const uploadTemplate = (params) => req.file("/site-service/m/site/template/upload", params);
